<nav class="navbar fixed-top navbar-expand-lg navbar-light">
  <a class="navbar-brand" href="#"
    ><img src="assets/images/startup-logo.png" class="img-fluid logo" alt="" />
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="search-div">
      <input
        class="form-control mr-sm-2"
        type="search"
        placeholder="Search incubatees"
        aria-label="Search"
      />
      <img src="assets/icons/search.png" class="img search-icon" alt="" />
    </div>
    <ul class="navbar-nav ml-auto mr-3">
      <li class="nav-item" routerLink="home" routerLinkActive="active">
        <a class="nav-link">Home</a>
      </li>
      <li class="nav-item" routerLink="about-us" routerLinkActive="active">
        <a class="nav-link">About Us</a>
      </li>
      <li class="nav-item" routerLink="incubators" routerLinkActive="active">
        <a class="nav-link">Startup Incubators</a>
      </li>
      <li class="nav-item" routerLink="event" routerLinkActive="active">
        <a class="nav-link">Events</a>
      </li>
      <li class="nav-item" routerLink="gallery" routerLinkActive="active">
        <a class="nav-link">Gallery</a>
      </li>
      <li class="nav-item" routerLink="blog" routerLinkActive="active">
        <a class="nav-link">Blog</a>
      </li>
      <li class="nav-item" routerLink="contact-us" routerLinkActive="active">
        <a class="nav-link">Contact Us</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <button
        (click)="registerBtn()"
        class="btn btn-register my-2 my-sm-0"
        type="submit"
      >
        Registration
      </button>
    </form>
  </div>
</nav>
